// [sv2] Standard categories for user message in bot conversation.
// Used to classify user message to determine best way to process.
// For example, greeting/small talk can be just answered, request for help needs RAG, Inappropriate content needs to be rejected.
// todo Consider adding "Status Check" category. For long-running tasks. When user says "Are you there ?", "Hello?", "What's going on?".
export const BOT_USER_MESSAGE_CATEGORIES = [
  {
    id: 'GREETING',
    definition: 'Greeting. Messages that start or open a conversation, often containing salutations.',
    examples: 'Hello!\nHi there!',
  },
  {
    id: 'FAREWELL',
    definition: 'Farewell. Messages indicating an end to the conversation.',
    examples: 'Thanks, bye!\nThat’s all for now.',
  },
  {
    id: 'SMALL_TALK',
    definition: 'Small Talk. Casual or non-essential conversation not directly requesting help or information.',
    examples: 'Nice weather today.\nHow’s your day going?',
  },
  {
    id: 'THANK_YOU',
    definition: 'Thank you or Appreciation. Expressions of gratitude or positive feedback for previous help.',
    examples: 'Thanks for explaining that.\nYou’re the best!',
  },
  {
    id: 'QUESTION',
    definition:
      'Request for Information or Help. The user is asking for for factual or additional details about a specific topic, assistance or guidance to solve a problem or perform a task.',
    examples: 'What are your hours of operation?\nCan you tell me more about your product’s features?\nHow do I set this up?\nI need help troubleshooting my printer.',
  },
  {
    id: 'ANSWER_CLARIFICATION',
    definition:
      'Answer to Clarification Question.\n' +
      'This category applies when the assistant previously asked a clarifying or context-gathering question about the user’s original request.\n' +
      'The user’s response supplies additional context or details necessary for the assistant to better answer or fulfill the original question.',
    examples: [
      'User: How do I set up my product?\nAssistant: Which product are you referring to, TaskManager or Task Planner?\nUser: I have TaskManager.',
      "User: I need help with installation. It's not working.\nAssistant: Could you tell me which operating system you’re using?\nUser: I’m on Windows 11.",
    ],
  },
  {
    id: 'ANSWER_DATA',
    definition:
      'Answer to Collect Data Question.\n' +
      'This category applies when the assistant specifically requests certain data needed for formal or logistical purposes.\n' +
      'The user’s response includes structured, identifiable information such as an email address, phone number, order number, account ID, reservation date/time, or other details that will be used to proceed with a next step (e.g., retrieving order info, booking a reservation, verifying identity).',
    examples: [
      'User: I have a problem with my last order.\nAssistant: I’m sorry to hear that. Could you provide your order number so I can look it up?\nUser: It’s #12345.',
      'Assistant: Can you share your name and email address?\nUser: John Smith, and my email is john.smith@example.com',
    ],
  },
  {
    id: 'FEEDBACK',
    definition: 'Feedback or Complaint. The user provides feedback (positive or negative) or complains about a product or service.',
    examples: 'I’m not happy with my order\nYour service is great, but I have some suggestions.',
  },
  {
    id: 'INAPPROPRIATE',
    definition: 'Inappropriate or Disallowed Content. The user’s message includes offensive or policy-violating content (harassment, hate speech, etc.).',
    examples: 'Explicit profanity; hateful slurs.',
  },
  {
    id: 'UNCLEAR',
    definition: 'Error or Unclear Message. The user’s message is incomplete, nonsensical, or too vague to act upon.',
    examples: '\n#@($)$??\n?????',
  },
];

export const BOT_USER_MESSAGE_CATEGORIES_BY_ID = {};
BOT_USER_MESSAGE_CATEGORIES.forEach((cat) => {
  BOT_USER_MESSAGE_CATEGORIES_BY_ID[cat.id] = cat;
});

// [sv2] These are default intents, should always be a starting point.
// These reflect the main purpose / behavior of QA bot.
export const BOT_DEFAULT_INTENTS = [
  {
    id: 'QUESTION',
    name: 'Request for Information or Help', // todo remove
    definition:
      'Request for Information or Help. The user is asking for for factual or additional details about a specific topic, assistance or guidance to solve a problem or perform a task.',
    examples: 'What are your hours of operation?\nCan you tell me more about your product’s features?\nHow do I set this up?\nI need help troubleshooting my printer.',
    rag: true,
    handoff: false,
  },
];

export const BOT_DEFAULT_INTENTS_BY_ID = {};
BOT_DEFAULT_INTENTS.forEach((intent) => {
  BOT_DEFAULT_INTENTS_BY_ID[intent.id] = intent;
});

// Bot Conversation Turn Action - what to do with the message
export const BOT_CONVERSATION_TURN_ACTION = Object.freeze({
  NONE: 'NONE', // No action
  PROCESS: 'PROCESS', // Process message as usual
  REJECT: 'REJECT', // Reject message, do not process
  HANDOFF: 'HANDOFF', // Handoff message to live agent
});
